import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { FloatingElements } from './ui/FloatingElements';
export function MethodSection() {
  const methodWords = 'Método de Reconexión de 7 Silencios'.split(' ');
  return <section id="method" className="py-32 px-4 md:px-8 relative overflow-hidden flex items-center min-h-[80vh]" data-id="element-167">
      {/* Background Image */}
      <img src="https://images.unsplash.com/photo-1518199266791-5375a83190b7?w=1400&q=80" alt="Manos de pareja conectando con calidez" className="absolute inset-0 w-full h-full object-cover z-0" data-id="element-168" />
      {/* Heavy Warm Overlay */}
      <div className="absolute inset-0 bg-rose-light/[0.88] z-[1]" data-id="element-169"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-rose-light/50 via-transparent to-rose-light/50 z-[2]" data-id="element-170"></div>

      {/* Giant Background 7 */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.8
    }} whileInView={{
      opacity: 0.06,
      scale: 1
    }} transition={{
      duration: 2,
      ease: 'easeOut'
    }} viewport={{
      once: true
    }} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[400px] md:text-[600px] font-serif text-burgundy leading-none select-none pointer-events-none z-[3]" data-id="element-171">
        7
      </motion.div>

      <FloatingElements count={4} colors={['bg-burgundy', 'bg-gold']} data-id="element-172" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-173">
        <FadeIn data-id="element-174">
          <div className="flex items-center justify-center gap-4 mb-8 opacity-60" data-id="element-175">
            <div className="w-12 h-[1px] bg-burgundy" data-id="element-176"></div>
            <div className="w-2 h-2 rotate-45 bg-gold" data-id="element-177"></div>
            <div className="w-12 h-[1px] bg-burgundy" data-id="element-178"></div>
          </div>

          <span className="text-sm font-bold tracking-widest text-burgundy uppercase mb-6 block" data-id="element-179">
            La Solución
          </span>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-burgundy-dark mb-10 leading-tight" data-id="element-180">
            Presentamos el <br className="hidden md:block mb-2" data-id="element-181" />
            <span className="italic text-gold-dark inline-flex flex-wrap justify-center gap-x-3" data-id="element-182">
              {methodWords.map((word, i) => <motion.span key={i} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.8,
              delay: i * 0.1 + 0.3
            }} data-id="element-183">
                  {word}
                </motion.span>)}
            </span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.8} data-id="element-184">
          <p className="text-lg md:text-xl text-charcoal leading-[1.8] max-w-2xl mx-auto" data-id="element-185">
            No es una terapia de pareja de meses. Es un mapa de identificación
            rápida para que entiendas exactamente qué cable se cortó en tu
            relación.
          </p>
          <p className="text-lg md:text-xl text-charcoal leading-[1.8] max-w-2xl mx-auto mt-6" data-id="element-186">
            Al nombrar el síntoma, le quitas su poder y activas tu energía
            femenina magnética, esa que hace que él vuelva a buscarte, no por
            obligación, sino por deseo genuino.
          </p>
        </FadeIn>

        <FadeIn delay={1} data-id="element-187">
          <a href="#pricing" className="group inline-flex items-center gap-2 mt-12 mx-auto bg-gold/20 hover:bg-gold/30 text-burgundy-dark font-semibold px-8 py-4 rounded-full border border-gold/40 hover:border-gold transition-all duration-300 text-lg" data-id="element-188">
            Quiero recuperar mi chispa
            <svg className="w-5 h-5 group-hover:translate-y-1 transition-transform duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} data-id="element-189">
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" data-id="element-190" />
            </svg>
          </a>
        </FadeIn>

        <FadeIn delay={1.2} data-id="element-191">
          <div className="flex items-center justify-center gap-4 mt-12 opacity-60" data-id="element-192">
            <div className="w-12 h-[1px] bg-burgundy" data-id="element-193"></div>
            <div className="w-2 h-2 rotate-45 bg-gold" data-id="element-194"></div>
            <div className="w-12 h-[1px] bg-burgundy" data-id="element-195"></div>
          </div>
        </FadeIn>
      </div>
    </section>;
}